import * as React from "react";
import { Link } from "react-router-dom";
import BrandMark from "../../assets/FlipIQ.png";
import { cn } from "../../lib/utils";

/** PRD 11.2: an agent's own name and logo in place of the Marketplace lockup */
export interface BrandIdentity {
  name: string;
  tagline?: string | null;
  logoUrl?: string | null;
}

interface BrandProps {
  to?: string;
  /** Icon only, for the collapsed sidebar */
  compact?: boolean;
  /** Light text for dark backgrounds */
  inverted?: boolean;
  className?: string;
  identity?: BrandIdentity;
}

const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("");

/** Horizontal Marketplace lockup: house mark + wordmark */
export const Brand: React.FC<BrandProps> = ({ to = "/", compact, inverted, className, identity }) => (
  <Link
    to={to}
    className={cn("group inline-flex items-center gap-2.5", className)}
    aria-label={identity ? `${identity.name} home` : "FlipIQ Marketplace home"}
  >
    <span
      className={cn(
        "flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-xl ring-1 transition-transform group-hover:scale-[1.04]",
        identity && !identity.logoUrl
          ? "bg-brand-600 text-sm font-bold text-white ring-brand-600"
          : inverted
            ? "bg-white/10 ring-white/15"
            : "bg-brand-50 ring-brand-100"
      )}
    >
      {identity ? (
        identity.logoUrl ? (
          <img src={identity.logoUrl} alt="" className="size-full object-cover" />
        ) : (
          initialsOf(identity.name)
        )
      ) : (
        <img src={BrandMark} alt="" className="h-6 w-auto" />
      )}
    </span>
    {!compact && (
      <span className="flex flex-col leading-none">
        <span
          className={cn(
            "text-base font-semibold tracking-tight",
            inverted ? "text-white" : "text-gray-900"
          )}
        >
          {identity ? identity.name : "Marketplace"}
        </span>
        <span className={cn("mt-0.5 text-xs", inverted ? "text-white/50" : "text-gray-400")}>
          {identity ? [identity.tagline, "powered by FlipIQ"].filter(Boolean).join(" · ") : "by FlipIQ"}
        </span>
      </span>
    )}
  </Link>
);
